import { defineComponent, inferProps, renderSlot, type ReactiveComponent } from "vue-utils"
import BootstrapButton from "../BootstrapButton"

interface Props {
	okText: string
	onClose: () => void
}

const AlertForm: ReactiveComponent<Props> = (props, { slots }) => {
	return () => (
		<form
			onSubmit={(e) => {
				e.preventDefault()
				props.onClose()
			}}
		>
			{renderSlot(slots)}
			<hr class="w-100" />
			<div class="d-flex justify-content-end">
				<BootstrapButton color="secondary" type="submit">
					{props.okText}
				</BootstrapButton>
			</div>
		</form>
	)
}

export default defineComponent(AlertForm, inferProps<Props>())
